var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormGroup',{staticClass:"o-form__checkbox",class:{
  'is-valid': _vm.showValidity && _vm.valid,
  'is-invalid': _vm.showValidity && !_vm.valid
}},[_c('input',_vm._g(_vm._b({ref:"input",staticClass:"o-form__checkbox__input",attrs:{"type":"checkbox","id":_vm.htmlId,"name":_vm.name},domProps:{"checked":_vm.value}},'input',_vm.inputAttributes,false),_vm.inputListeners)),_c('label',{staticClass:"o-form__checkbox__label",attrs:{"for":_vm.htmlId}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }